import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import VendorsState, { Vendor } from "@tKgpco/Store/Data/Vendors/VendorsState";
import { Draft } from "immer";

const initialState: VendorsState = {
    isLoading: false,
    vendors: [],
    vendorsFetched: false,
};
export const reducer = {
    "Data/Custom/StartFetchingVendors": (draft: Draft<VendorsState>) => {
        draft.isLoading = true;
    },
    "Data/Custom/CompleteFetchingVendors": (draft: Draft<VendorsState>, action: { vendors: Vendor[] }) => {
        draft.isLoading = false;
        draft.vendors = action.vendors;
        draft.vendorsFetched = true;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
